module.exports = __webpack_public_path__ + "media/images/bg_home-664b0732eecd8b2a13f3baae6f0d86f5.webp";